<script>
    export const UIdata = {
        vis: {
            annotations: {
                type: "boolean",
                default: true,
                description: "",
                component: "checkbox",
                title: "Show annotations?",
                sort: 1,
            },
            colorType: {
                type: "string",
                default: "zGradient",
                enum: [
                    "zGradient",
                    "RandomBlue",
                    "PrintSequence",
                    "PrintSequenceFluctuating",
                ],
                description: "",
                component: "dropdown",
                title: "Color",
                values: [
                    "zGradient",
                    "RandomBlue",
                    "PrintSequence",
                    "PrintSequenceFluctuating",
                ],
                sort: 2,
            },
            lineWidth: {
                type: "number",
                minimum: 1,
                maximum: 10,
                default: 3,
                description:
                    "Affects display only - not gcode. If you have expertise in three.js, and want to improve the visuals, contact info@fullcontrol.xyz",
                component: "slider",
                step: 1,
                title: "Line thickness in display",
                sort: 3,
            },
        },
        printer: {
            printer_name: {
                type: "string",
                // default: "Prusa_i3",
                default: "generic",
                enum: [
                    // "Prusa_i3",
                    // "Ender3",
                    // "Ultimaker2plus",
                    // "BambuLabX1",
                    // "E3D_tool_changer_T0",
                    // "E3D_tool_changer_T1",
                    // "E3D_tool_changer_T2",
                    // "E3D_tool_changer_T3",
                    // "CR10",
                    // "Generic",
                    "prusa_i3",
                    "ender_3",
                    "ultimaker2plus",
                    "bambulab_x1",
                    "toolchanger_T0",
                    "toolchanger_T1",
                    "toolchanger_T2",
                    "toolchanger_T3",
                    "cr_10",
                    "generic",
                ],
                description:
                    "Other printers will be added soon. If you cannot wait, and understand gcode, choose a printer from the list then manually replace the start/end gcode. An option for absolute extrusion (M82) will be added soon",
                component: "dropdown",
                title: "Printer",
                values: [
                    "Prusa_i3",
                    "Ender3",
                    "Ultimaker2plus",
                    "BambuLabX1",
                    "E3D_tool_changer_T0",
                    "E3D_tool_changer_T1",
                    "E3D_tool_changer_T2",
                    "E3D_tool_changer_T3",
                    "CR10",
                    "Generic",
                ],
                sort: 1,
            },
            nozzle_temp: {
                type: "number",
                minimum: 50,
                maximum: 600,
                default: 210,
                description: "",
                component: "numberinput",
                title: "Nozzle temperature (°C)",
                sort: 2,
            },
            bed_temp: {
                type: "number",
                minimum: 0,
                maximum: 200,
                default: 50,
                description: "",
                component: "numberinput",
                step: 3,
                title: "Bed temperature (°C)",
                sort: 2,
            },
            fan_percent: {
                type: "number",
                minimum: 0,
                maximum: 100,
                default: 100,
                description: "",
                component: "numberinput",
                title: "Fan speed (%)",
                sort: 4,
            },
            material_flow_percent: {
                type: "number",
                minimum: 1,
                maximum: 1000,
                default: 100,
                description: "",
                component: "numberinput",
                title: "Material flow (%)",
                sort: 5,
            },
            print_speed_percent: {
                type: "number",
                minimum: 1,
                maximum: 1000,
                default: 100,
                description: "",
                component: "numberinput",
                title: "Print speed (%)",
                sort: 6,
            },
        },
    };
</script>
